// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"style__wrapper___2sH5U"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/addRecipe/style.scss
 ** module id = 359
 ** module chunks = 0
 **/